import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { offerAgreementsAPI } from "api/api/offerAgreementsApi/offerAgreementsApi";
import { UpdateMarathonAgreementsByMarathonIdBody, UpdateMarathonAgreementsByMarathonIdRes } from "api/api/offerAgreementsApi/types";

export const updateMarathonAgreementsByMarathonId = createAsyncThunk<
  UpdateMarathonAgreementsByMarathonIdRes,
  UpdateMarathonAgreementsByMarathonIdBody
>("statuses/updateMarathonAgreementsByMarathonId", async (body, { rejectWithValue }) => {
  try {
    const data = await offerAgreementsAPI.updateMarathonAgreementsByMarathonId(body);
    return data;
  } catch (error: unknown) {
    if (axios.isAxiosError(error)) {
      console.error("Error while updating marathon agreements", error.response?.data);
      return rejectWithValue(error.response?.data || "Unknown error");
    } else {
      console.error("Error while updating marathon agreements", error);
      return rejectWithValue(
        "Что-то пошло не так... Попробуйте обновить страницу"
      );
    }
  }
});
